
import compass_outer from './compass-outer';


const Icons = {
  compass_outer,

};

export default Icons;
